export default "__VITE_ASSET__DZrpBGsc__"